module.exports = __webpack_public_path__ + "img/certificate-IM-Excellent.f0e4f273.png";